module.exports = __webpack_public_path__ + "assets/img/wxkf.63d8cc4e.jpg";